import { List as MuiList, ListProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { ListProps };

export const List: React.ComponentType<ListProps> = styled(MuiList)<ListProps>(() => ({}));
